let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");

module.exports = function(Displaylists/*, sids... */){
	let sids = esUtils.cleanup_ids(_.flattenDeep(_.tail(_.toArray(arguments))));
	return _.filter(Displaylists && Displaylists.perspeaker, function(spkr){
		return _.includes(sids, spkr.sid);
	});
};



// WEBPACK FOOTER //
// ./src/utils/getSpeakersFromDisplaylists.js